!(function () {
    "use strict";
    var e,
        t = {
            1287: function (e, t, r) {
                r.d(t, {
                    p: function () {
                        return i;
                    },
                });
                var n = r(4662),
                    s = r(4739);
                const i = () => {
                    const e = document
                            .querySelector(".opk-recommendations-wrapper")
                            .querySelectorAll('form[data-type="add-to-cart-form"]'),
                        t = document.getElementById("main-cart"),
                        r = document.getElementById("mini-cart"),
                        i = document.querySelector("body");
                    e.length &&
                        e.forEach((e) =>
                            e.addEventListener("submit", (a) => {
                                a.preventDefault(),
                                    a.stopPropagation(),
                                    a.target.querySelector(
                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                    ) &&
                                        (a.target.querySelector(
                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                        ).textContent = `${cartStrings.addingToCart}`);
                                const o = a.target.querySelector('button[type="submit"]'),
                                    c = o.querySelector("span.cart-icon"),
                                    l = o.querySelector("svg.loading-icon");
                                i.classList.remove("added-to-cart"),
                                    o.classList.add("added"),
                                    (c.style.display = "none"),
                                    (l.style.display = "block");
                                const d = (0, n.Dz)("javascript");
                                (d.headers["X-Requested-With"] = "XMLHttpRequest"), delete d.headers["Content-Type"];
                                const u = new FormData(e);
                                u.append("sections", "main-cart"),
                                    (d.body = u),
                                    fetch(`${routes.cartAdd}`, d)
                                        .then((e) => e.json())
                                        .then(async (e) => {
                                            if (e.status) {
                                                if (
                                                    (s.A.updateMiniCart(!0),
                                                    (c.style.display = "inline-flex"),
                                                    (l.style.display = "none"),
                                                    a.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (a.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addToCart}`),
                                                    "object" == typeof e.description)
                                                )
                                                    return Object.entries(e.description).forEach(([e, t]) => {
                                                        const r = `${t.join(", ")}`;
                                                        a.target.querySelector(".main-product__error").innerHTML =
                                                            '<span class="icon loaded">error</span><p>' + r + "</p>";
                                                    });
                                                a.target.querySelector(".main-product__error").innerHTML =
                                                    '<span class="icon loaded">error</span><p>' +
                                                    e.description +
                                                    "</p>";
                                            } else {
                                                if ("cart" === cartStrings.uxCart)
                                                    return void (window.location.href = window.routes.cart);
                                                if (
                                                    ((a.target.querySelector(".main-product__error").innerHTML = ""),
                                                    t && t.classList.add("added"),
                                                    e.sections && null !== e.sections["main-cart"])
                                                )
                                                    s.A.renderItems(
                                                        new DOMParser().parseFromString(
                                                            e.sections["main-cart"],
                                                            "text/html"
                                                        )
                                                    );
                                                else {
                                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                                    fetch(e)
                                                        .then((e) => e.text())
                                                        .then((e) => {
                                                            s.A.renderItems(
                                                                new DOMParser().parseFromString(e, "text/html")
                                                            );
                                                        });
                                                }
                                                "mini-cart" === cartStrings.uxCart && r && r.open(),
                                                    a.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (a.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addedToCart}`),
                                                    o.classList.remove("added"),
                                                    o.classList.add("successful"),
                                                    (c.style.display = "flex"),
                                                    (l.style.display = "none"),
                                                    i.classList.add("added-to-cart");
                                            }
                                        })
                                        .catch((e) => {
                                            console.error("Error:", e);
                                        });
                            })
                        );
                };
            },
            4662: function (e, t, r) {
                r.d(t, {
                    Dz: function () {
                        return n;
                    },
                    sg: function () {
                        return s;
                    },
                });
                const n = (e = "json") => ({
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
                });
                function s(e, t) {
                    const r = this;
                    let n;
                    return function () {
                        for (var s = arguments.length, i = new Array(s), a = 0; a < s; a++) i[a] = arguments[a];
                        clearTimeout(n),
                            (n = setTimeout(function () {
                                return e.apply(r, i);
                            }, t));
                    };
                }
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        !(function (e, t = 0) {
                            const r = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                s = e.getBoundingClientRect().top;
                            window.scrollTo({
                                top:
                                    "off" !== n
                                        ? s + window.scrollY - t + parseFloat(r.style.marginTop)
                                        : s + window.scrollY - t,
                                behavior: "smooth",
                            });
                        })(document.querySelector(t));
                    });
                });
            },
            4739: function (e, t, r) {
                var n = r(4662);
                const s = new (class {
                    constructor() {
                        (this.items = Array.from(document.querySelectorAll(".cart-item"))),
                            this.items.forEach((e) => this.manageState(e)),
                            (this.selectorsToUpdate = [
                                ".cart-summary__header",
                                "#cart-total-price",
                                "#checkout",
                                ".cart-summary__free-shipping",
                            ]),
                            (this.mainCartSelector = ".shopify-section.cart"),
                            (this.miniCart = document.getElementById("mini-cart")),
                            (this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty"),
                            (this.parser = new DOMParser());
                    }
                    manageState(e) {
                        const t = e.getAttribute("data-variant-id");
                        e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () => {
                            await this.changeCartItem({ id: t, quantity: 0 }), e.remove();
                        });
                        const r = e.querySelector('input[name="quantity"]');
                        if (!r) return;
                        const n = e.querySelector('button[name="plus"]'),
                            s = e.querySelector('button[name="minus"]'),
                            i = e.querySelector('input[name="quantity"]');
                        let a = parseInt(r.value);
                        n.addEventListener("click", () => {
                            (a += 1), (r.value = a), this.changeCartItem({ id: t, quantity: a });
                        }),
                            s.addEventListener("click", () => {
                                (a -= 1), (r.value = a), this.changeCartItem({ id: t, quantity: a });
                            }),
                            i.addEventListener("change", (e) => {
                                parseInt(e.target.value) > 0
                                    ? ((a = parseInt(e.target.value)), this.changeCartItem({ id: t, quantity: a }))
                                    : (i.value = a);
                            }),
                            i.addEventListener("keypress", (e) => {
                                ((8 !== e.which && 0 !== e.which && e.which < 48) || e.which > 57) &&
                                    e.preventDefault();
                            });
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, n.Dz)(),
                            body: JSON.stringify({ line: +e.id, quantity: e.quantity, sections: "main-cart" }),
                        };
                        fetch(`${routes.cartChange}`, t)
                            .then((e) => e.json())
                            .then((e) => {
                                const t = (t) => {
                                    const r = this.parser.parseFromString(t, "text/html");
                                    if (0 === e.item_count) {
                                        const e = document.querySelector(this.mainCartSelector);
                                        e && (e.innerHTML = r.querySelector(this.mainCartSelector).innerHTML),
                                            this.renderElements(r);
                                    } else this.renderItems(r);
                                };
                                if (e.sections && null !== e.sections["main-cart"]) t(e.sections["main-cart"]);
                                else {
                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((e) => {
                                            t(e);
                                        });
                                }
                                const r = `${window.location.pathname}?section_id=navigation-main`;
                                fetch(r)
                                    .then((e) => e.text())
                                    .then((t) => {
                                        const r = this.parser.parseFromString(t, "text/html");
                                        if (0 === e.item_count) {
                                            const e = document.querySelector("#mini-cart");
                                            e &&
                                                ((e.innerHTML = r.querySelector("#mini-cart").innerHTML),
                                                e.addEventListeners(),
                                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")));
                                        }
                                    });
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t) => {
                            try {
                                const r = document.querySelectorAll(t),
                                    n = e.querySelector(t);
                                r.length &&
                                    n &&
                                    r.forEach((e) => {
                                        n.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                            e.replaceWith(n.cloneNode(!0));
                                    });
                            } catch (e) {
                                console.error(`Error updating ${t}`, e);
                            }
                        });
                        const t = e.querySelector(".cart-count");
                        document
                            .querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count")
                            .forEach((e) => {
                                t
                                    ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"),
                                      (e.textContent = t.textContent))
                                    : e.classList.add("visually-hidden");
                            }),
                            document.querySelector("#cart-open-block .icon").classList.add("loaded");
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            r = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e) => {
                            e && e.replaceWith(r.cloneNode(!0));
                        }),
                            document.querySelectorAll(".cart-item").forEach((e) => {
                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                    this.manageState(e);
                            });
                    }
                    updateMiniCart(e) {
                        return fetch("/?section_id=main-cart")
                            .then((e) => e.text())
                            .then((t) => {
                                this.renderItems(new DOMParser().parseFromString(t, "text/html")),
                                    e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open();
                            })
                            .catch((e) => {
                                console.error("Error updating mini cart:", e);
                            });
                    }
                })();
                (t.A = s),
                    customElements.get("cart-note") ||
                        customElements.define(
                            "cart-note",
                            class extends HTMLElement {
                                constructor() {
                                    super(),
                                        this.querySelector("textarea").addEventListener(
                                            "change",
                                            (0, n.sg)((e) => {
                                                const t = JSON.stringify({ note: e.target.value });
                                                fetch(`${routes.cartUpdate}`, { ...(0, n.Dz)(), body: t });
                                            }, 300)
                                        );
                                }
                            }
                        );
            },
            7207: function (e, t, r) {
                var n = r(9138),
                    s = r(1287);
                const i = (e) => {
                        const t = e.dataset.url;
                        fetch(t)
                            .then((e) => e.text())
                            .then((t) => {
                                const r = document.createElement("div");
                                r.innerHTML = t;
                                const i = r.querySelector(".product-recommendations");
                                if (i && i.innerHTML.trim().length) {
                                    const t = e.closest(".shopify-section");
                                    t.classList.add("u-hide"),
                                        (e.innerHTML = i.innerHTML),
                                        new n.b(),
                                        (0, s.p)(),
                                        setTimeout(() => {
                                            t.classList.remove("u-hide");
                                        }, 1e3);
                                }
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    },
                    a = document.querySelectorAll(".product-recommendations"),
                    o = new IntersectionObserver(
                        (e, t) => {
                            e.forEach((e) => {
                                e.isIntersecting && (t.unobserve(e.target), i(e.target));
                            });
                        },
                        { rootMargin: "0px 0px 200px 0px" }
                    );
                a.forEach((e) => {
                    o.observe(e);
                }),
                    Shopify.designMode &&
                        document.addEventListener("shopify:section:load", () => {
                            a.forEach((e) => {
                                i(e);
                            });
                        });
            },
            9138: function (e, t, r) {
                r.d(t, {
                    b: function () {
                        return n;
                    },
                }),
                    (0, r(2169).kz)();
                class n {
                    constructor() {
                        this.initializeSwipers(),
                            Shopify.designMode &&
                                document.addEventListener("shopify:section:load", () => this.initializeSwipers());
                    }
                    initializeSwipers() {
                        document.querySelectorAll("swiper-container").forEach((e) => {
                            e.dataset.mobileSlidesPerView;
                            const t =
                                    (e.dataset.desktopSlidesPerView,
                                    "0" !== e.dataset.tabletSlidesPerView &&
                                        e.dataset.tabletSlidesPerView &&
                                        e.dataset.tabletSlidesPerView,
                                    "true" === e.dataset.textPagination),
                                r = Number(e.dataset.spaceBetweenMobile) || 16,
                                n = Number(e.dataset.spaceBetweenTablet) || 32,
                                s = Number(e.dataset.spaceBetweenDesktop) || 32,
                                i = e.dataset.mobileLayout || "slider",
                                a = e.dataset.desktopLayout || "slider",
                                o = window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
                                c = window.matchMedia("(min-width: 1024px)"),
                                l = () => {
                                    e.querySelectorAll("video").forEach((e) => {
                                        e.classList.contains("section__wrapper-background") || e.pause();
                                    }),
                                        Array.from(e.querySelectorAll("swiper-slide"))
                                            .filter((e) => e.classList.contains("swiper-slide-visible"))
                                            .forEach((e) => {
                                                const t = e.querySelector("video");
                                                t && t.hasAttribute("autoplay") && t.play();
                                            });
                                },
                                d = () => {
                                    const t = e.closest(".slideshow-text-controls__wrapper");
                                    if (!t) return;
                                    const r = e.swiper.slides[e.swiper.realIndex];
                                    if (!r) return;
                                    const n = r.getAttribute("data-slide");
                                    t.querySelectorAll(".slideshow-text-controls__item").forEach((e) => {
                                        e.classList.toggle("active", e.getAttribute("data-slide") === n);
                                    });
                                },
                                u = () => {
                                    if ((c.matches && "slider" === a) || (o.matches && "slider" === i))
                                        if (!e.swiper || e.swiper.destroyed) {
                                            const i = parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                                                a =
                                                    "0" !== e.dataset.tabletSlidesPerView &&
                                                    e.dataset.tabletSlidesPerView
                                                        ? parseFloat(e.dataset.tabletSlidesPerView)
                                                        : i,
                                                o = parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                                                c = {
                                                    ...(e.parentElement?.classList.contains("card__image")
                                                        ? { virtual: { enabled: !0 }, nested: !0 }
                                                        : {}),
                                                    breakpoints: {
                                                        0: { slidesPerView: i, spaceBetween: parseInt(r) },
                                                        768: { slidesPerView: a, spaceBetween: parseInt(n) },
                                                        1024: { slidesPerView: o, spaceBetween: parseInt(s) },
                                                    },
                                                };
                                            Object.assign(e, c),
                                                e.addEventListener("swiperafterinit", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t && t.classList.add("slider-enabled"),
                                                        setTimeout(() => {
                                                            if (!e.swiper) return;
                                                            const t = e.swiper?.slides?.length || 0,
                                                                r = t < i ? t : i,
                                                                n = t < a ? t : a,
                                                                s = t < o ? t : o;
                                                            e.swiper &&
                                                                e.swiper.params &&
                                                                e.swiper.params.breakpoints &&
                                                                ((e.swiper.currentBreakpoint = !1),
                                                                (e.swiper.params.breakpoints[0].slidesPerView = r),
                                                                (e.swiper.params.breakpoints[768].slidesPerView = n),
                                                                (e.swiper.params.breakpoints[992].slidesPerView = s),
                                                                e.swiper.update(),
                                                                e.swiper.slideTo(0, 0, !1)),
                                                                l(),
                                                                (() => {
                                                                    const t = e
                                                                        .closest(".main-product__media-wrapper")
                                                                        ?.querySelector(".swiper-thumbnails .swiper");
                                                                    t &&
                                                                        (Object.assign(t, {
                                                                            direction: "vertical",
                                                                            slidesPerView: "auto",
                                                                            spaceBetween: 8,
                                                                            watchSlidesProgress: !0,
                                                                            navigation: {
                                                                                nextEl: ".swiper-button-thumbs-next",
                                                                                prevEl: ".swiper-button-thumbs-prev",
                                                                            },
                                                                            breakpoints: {
                                                                                0: {
                                                                                    direction: "horizontal",
                                                                                    slidesPerView: 4,
                                                                                },
                                                                                768: {
                                                                                    direction: "vertical",
                                                                                    slidesPerView: "auto",
                                                                                },
                                                                            },
                                                                        }),
                                                                        t.initialize());
                                                                })();
                                                        }, 0);
                                                }),
                                                e.addEventListener("swiperslidechange", () => {
                                                    l(), d();
                                                }),
                                                e.addEventListener("swiperdestroy", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t && t.classList.remove("slider-enabled");
                                                }),
                                                e.addEventListener("swiperlock", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t &&
                                                        !t.classList.contains("recommended-products") &&
                                                        setTimeout(() => {
                                                            t.querySelectorAll(".grid-content__slider-nav").forEach(
                                                                (e) => {
                                                                    e.style.display = "none";
                                                                }
                                                            );
                                                        }, 1);
                                                }),
                                                e.initialize(),
                                                t &&
                                                    ((() => {
                                                        if (!t) return;
                                                        const r = e.closest(".slideshow-text-controls__wrapper");
                                                        r &&
                                                            r
                                                                .querySelectorAll(".slideshow-text-controls__item")
                                                                .forEach((t) => {
                                                                    t.addEventListener("click", () => {
                                                                        const r = t.getAttribute("data-slide"),
                                                                            n = Array.from(e.swiper.slides).findIndex(
                                                                                (e) =>
                                                                                    e.getAttribute("data-slide") === r
                                                                            );
                                                                        -1 !== n && e.swiper.slideTo(n);
                                                                    });
                                                                });
                                                    })(),
                                                    d());
                                        } else e.swiper.update();
                                    else if ((Object.assign(e), e.initialize(), e.swiper)) {
                                        e.swiper.destroy(!0, !0);
                                        const t = e.closest(".shopify-section");
                                        t && t.classList.remove("slider-enabled");
                                    }
                                };
                            window.addEventListener("resize", u), u();
                        });
                    }
                }
                new n();
            },
        },
        r = {};
    function n(e) {
        var s = r[e];
        if (void 0 !== s) return s.exports;
        var i = (r[e] = { exports: {} });
        return t[e](i, i.exports, n), i.exports;
    }
    (n.m = t),
        (e = []),
        (n.O = function (t, r, s, i) {
            if (!r) {
                var a = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    (r = e[d][0]), (s = e[d][1]), (i = e[d][2]);
                    for (var o = !0, c = 0; c < r.length; c++)
                        (!1 & i || a >= i) &&
                        Object.keys(n.O).every(function (e) {
                            return n.O[e](r[c]);
                        })
                            ? r.splice(c--, 1)
                            : ((o = !1), i < a && (a = i));
                    if (o) {
                        e.splice(d--, 1);
                        var l = s();
                        void 0 !== l && (t = l);
                    }
                }
                return t;
            }
            i = i || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > i; d--) e[d] = e[d - 1];
            e[d] = [r, s, i];
        }),
        (n.d = function (e, t) {
            for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.j = 1157),
        (function () {
            var e = { 1157: 0, 1457: 0, 1653: 0, 2325: 0, 3498: 0 };
            n.O.j = function (t) {
                return 0 === e[t];
            };
            var t = function (t, r) {
                    var s,
                        i,
                        a = r[0],
                        o = r[1],
                        c = r[2],
                        l = 0;
                    if (
                        a.some(function (t) {
                            return 0 !== e[t];
                        })
                    ) {
                        for (s in o) n.o(o, s) && (n.m[s] = o[s]);
                        if (c) var d = c(n);
                    }
                    for (t && t(r); l < a.length; l++) (i = a[l]), n.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
                    return n.O(d);
                },
                r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
            r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r)));
        })();
    var s = n.O(void 0, [8096], function () {
        return n(7207);
    });
    s = n.O(s);
})();
